import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PARTNERS } from "../../../constant/CarouselData";
import Eyebrow from "../../common/Eyebrow";

const BrandPartnersMain = () => {
  return (
    <>
      <section className="bg-white px-6 py-20">
        <div className="mx-auto max-w-6xl text-center">
          <Eyebrow>Ecosystem</Eyebrow>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
            Brands &amp; Partners
          </h2>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-slate-600">
            Trusted by leading brands and partners across the IT hardware and
            infrastructure ecosystem.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {PARTNERS.map((partner, index) => {
              const imageSrc = partner.imageUrl
                ? require(`./../../../assets/Partners/${partner.imageUrl}`)
                : require(`./../../../assets/Partners/cisco.png`);

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.4, delay: (index % 12) * 0.05 }}
                  className="flex items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.6)] hover:shadow-lg"
                >
                  <img
                    src={imageSrc}
                    alt={partner.name}
                    className="h-12 max-w-full object-contain transition duration-300 hover:scale-110"
                    loading="lazy"
                  />
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-[var(--surface-dark)] px-6 py-20 text-center">
        <div className="mx-auto max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--website-secondary-color)]">
            Work with us
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-white md:text-4xl">
            Partner with QuantaRock Systems
          </h2>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-slate-300">
            Choosing QuantaRock Systems for your IT needs means partnering
            with a trusted advisor committed to your success. We bring deep
            industry knowledge, technical expertise, and a customer-centric
            approach to deliver solutions that drive tangible results.
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-flex rounded-full bg-[var(--website-secondary-color)] px-6 py-3 text-sm font-semibold text-[var(--on-secondary)] transition hover:brightness-110"
          >
            Talk to our team
          </Link>
        </div>
      </section>
    </>
  );
};

export default BrandPartnersMain;
